import { HStackProps } from './HStack.interfaces';
import styles from './HStack.module.scss';

const HStack = ({ justify, children }: HStackProps) => {
  return (
    <div className={styles.base} data-justify={justify}>
      {children}
    </div>
  );
};

export default HStack;
